export const partnerTypes = [
  { value: 'influencer', name: 'influencer' },
  { value: 'promoter', name: 'promoter' },
  { value: 'athletic', name: 'athletic' },
  { value: 'republic', name: 'republic' },
  { value: 'agency', name: 'agency' },
  { value: 'academic_centre', name: 'academic_centre' },
  {
    value: 'academic_directory',
    name: 'academic_directory',
  },
  { value: 'band', name: 'band' },
  {
    value: 'independent_partner',
    name: 'independent_partner',
  },
];
